import React, { Fragment, useEffect } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Footer from "../components/partials/Footer";
import Header from "../components/partials/Header";

const PrivacyPolicy = (props) => {
  useEffect(() => {
    document.body.classList.remove("img-bg");
    window.scrollTo(0, 0);
  });
  return (
    <Fragment>
      <Header {...props} heading="Privacy Policy" />
      <div className="margin-top-fix text-white-1">
        <Container>
          <Card className="bg-dark-1 custom-card">
            <CardBody>
              <div className="card-content">
                <p className="text-grey-1 text-justify p-text">
                  Cluerush built the Cluerush app as a Commercial app. This
                  SERVICE is provided by Cluerush and is intended for use as is.
                  <br /> This page is used to inform visitors regarding our
                  policies with the collection, use, and disclosure of Personal
                  Information if anyone decided to use our Service.
                  <br /> If you choose to use our Service, then you agree to the
                  collection and use of information in relation to this policy.
                  The Personal Information that we collect is used for providing
                  and improving the Service. We will not use or share your
                  information with anyone except as described in this Privacy
                  Policy.
                  <br /> The terms used in this Privacy Policy have the same
                  meanings as in our Terms and Conditions, which is accessible
                  at Cluerush unless otherwise defined in this Privacy Policy.
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  1 - Information Collection and Use
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  For a better experience, while using our Service, we may
                  require you to provide us with certain personally identifiable
                  information, including but not limited to name,location,email.
                  The information that we request will be retained by us and
                  used as described in this privacy policy.
                  <br /> The app does use third party services that may collect
                  information used to identify you.
                  <br /> Link to privacy policy of third party service providers
                  used by the app
                  <br />
                  <ul>
                    <li>
                      <a
                        href="https://policies.google.com/privacy"
                        target="_blank"
                      >
                        Google Play Services
                      </a>
                    </li>
                  </ul>
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  2 - Log Data
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  We want to inform you that whenever you use our Service, in a
                  case of an error in the app we collect data and information
                  (through third party products) on your phone called Log Data.
                  This Log Data may include information such as your device
                  Internet Protocol (“IP”) address, device name, operating
                  system version, the configuration of the app when utilizing
                  our Service, the time and date of your use of the Service, and
                  other statistics.
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">3 - Cookies</h5>
                <p className="text-grey-1 text-justify p-text">
                  Cookies are files with a small amount of data that are
                  commonly used as anonymous unique identifiers. These are sent
                  to your browser from the websites that you visit and are
                  stored on your device's internal memory.
                  <br /> This Service does not use these “cookies” explicitly.
                  However, the app may use third party code and libraries that
                  use “cookies” to collect information and improve their
                  services. You have the option to either accept or refuse these
                  cookies and know when a cookie is being sent to your device.
                  If you choose to refuse our cookies, you may not be able to
                  use some portions of this Service.
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  4 - Service Providers
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  We may employ third-party companies and individuals due to the
                  following reasons:
                  <ul>
                    <li>To facilitate our Service;</li>
                    <li>To provide the Service on our behalf;</li>
                    <li>To perform Service-related services; or</li>
                    <li>To assist us in analyzing how our Service is used.</li>
                  </ul>
                  We want to inform users of this Service that these third
                  parties have access to your Personal Information. The reason
                  is to perform the tasks assigned to them on our behalf.
                  However, they are obligated not to disclose or use the
                  information for any other purpose.
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  5 - Security
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  We value your trust in providing us your Personal Information,
                  thus we are striving to use commercially acceptable means of
                  protecting it. But remember that no method of transmission
                  over the internet, or method of electronic storage is 100%
                  secure and reliable, and we cannot guarantee its absolute
                  security.{" "}
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  6 - Links to Other Sites
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  This Service may contain links to other sites. If you click on
                  a third-party link, you will be directed to that site. Note
                  that these external sites are not operated by us. Therefore,
                  we strongly advise you to review the Privacy Policy of these
                  websites. We have no control over and assume no responsibility
                  for the content, privacy policies, or practices of any
                  third-party sites or services
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  7 - Children’s Privacy
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  These Services do not address anyone under the age of 13. We
                  do not knowingly collect personally identifiable information
                  from children under 13 years of age. In the case we discover
                  that a child under 13 has provided us with personal
                  information, we immediately delete this from our servers. If
                  you are a parent or guardian and you are aware that your child
                  has provided us with personal information, please contact us
                  so that we will be able to do necessary actions.
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  8 - Changes to This Privacy Policy
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  We may update our Privacy Policy from time to time. Thus, you
                  are advised to review this page periodically for any changes.
                  We will notify you of any changes by posting the new Privacy
                  Policy on this page.
                  <br />
                  This policy is effective as of 2021-06-13
                </p>
              </div>
              <div className="card-content mt-4">
                <h5 className="text-red-1 font-weight-semibold">
                  9 - Contact Us
                </h5>
                <p className="text-grey-1 text-justify p-text">
                  If you have any questions or suggestions about our Privacy
                  Policy, do not hesitate to contact us at a.omar@springyuniverse.com.
                  <br />
                  This privacy policy page was created at &nbsp;
                  <a
                    href="https://www.privacypolicytemplate.net/"
                    target="_blank"
                  >
                    privacypolicytemplate.net
                  </a>{" "}
                  and modified/generated by{" "}
                  <a
                    href="https://app-privacy-policy-generator.nisrulz.com/"
                    target="_blank"
                  >
                    App Privacy Policy Generator
                  </a>
                  .
                </p>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
      <Footer />
    </Fragment>
  );
};

export default PrivacyPolicy;
